var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMedicare64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Medicare64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogramMedicare",
    transform: "translate(5.000000, 15.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 54,
    height: 34,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,8.5 C33,6.56700338 34.5632794,5 36.4914967,5 L49,5 L49,8.5 C49,10.4329966 47.4367206,12 45.5085033,12 L33,12 L33,8.5 Z",
    id: "Logo",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(7.000000, 18.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2,1.13043478 L31.2,1.13043478",
    id: "Line-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.2,7.13043478 L19.2,7.13043478",
    id: "Line-2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMedicare64);
export default __webpack_public_path__ + "static/media/pictogramMedicare64.a9a7552de1c47d4fe4b14fede16d7869.svg";
export { ForwardRef as ReactComponent };